import { createClient } from '@supabase/supabase-js';

const sanitizeEnv = (value = '') => value.trim().replace(/^['"]|['"]$/g, '');

const rawSupabaseUrl = sanitizeEnv(process.env.REACT_APP_SUPABASE_URL || '');
const supabaseAnonKey = sanitizeEnv(process.env.REACT_APP_SUPABASE_ANON_KEY || '').replace(/[\r\n\s]+/g, '');

const decodeBase64Url = (value = '') => {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
    return atob(padded);
  } catch {
    return '';
  }
};

const normalizeSupabaseUrl = (value) => {
  if (!value) return '';
  try {
    const parsed = new URL(value);
    return parsed.origin;
  } catch {
    return '';
  }
};

const deriveSupabaseUrlFromAnonKey = (anonKey) => {
  try {
    const parts = String(anonKey || '').split('.');
    if (parts.length < 2) return '';
    const payloadRaw = decodeBase64Url(parts[1]);
    if (!payloadRaw) return '';
    const payload = JSON.parse(payloadRaw);
    const ref = String(payload?.ref || '').trim();
    if (!ref) return '';
    return `https://${ref}.supabase.co`;
  } catch {
    return '';
  }
};

const derivedSupabaseUrl = normalizeSupabaseUrl(deriveSupabaseUrlFromAnonKey(supabaseAnonKey));
const supabaseUrl =
  normalizeSupabaseUrl(rawSupabaseUrl) ||
  derivedSupabaseUrl;

// Robust check to ensure variables are not only present but also valid
const isValidConfig = 
  supabaseUrl && 
  supabaseUrl.startsWith('http') && 
  supabaseAnonKey && 
  supabaseAnonKey.length > 20;

if (!isValidConfig) {
  console.error("Supabase Config Error:", {
    urlPresent: !!supabaseUrl,
    urlValid: supabaseUrl?.startsWith('http'),
    keyPresent: !!supabaseAnonKey,
    help: "Ensure REACT_APP_SUPABASE_URL (starts with https://) and REACT_APP_SUPABASE_ANON_KEY are set in Vercel."
  });
}

export const supabase = isValidConfig 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export const supabaseConfigMeta = {
  rawUrlPresent: !!rawSupabaseUrl,
  normalizedUrl: supabaseUrl || null,
  derivedUrl: derivedSupabaseUrl || null,
  anonKeyPresent: !!supabaseAnonKey,
  anonKeyLength: supabaseAnonKey ? supabaseAnonKey.length : 0,
  isValidConfig,
};
